var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "settings-internal-plugins" }, [
    _c(
      "ul",
      { staticClass: "settings-internal-plugins__list" },
      _vm._l(_vm.plugins, function(plugin, indexPlugin) {
        return _c(
          "li",
          {
            key: indexPlugin,
            staticClass: "settings-internal-plugins__list-item"
          },
          [
            _c(
              "a",
              {
                attrs: {
                  href: plugin.url,
                  onClick: plugin.call,
                  target: plugin.target
                }
              },
              [
                plugin.compassicon
                  ? _c("CompassIcon", {
                      attrs: { icon: plugin.compassicon, size: "large" }
                    })
                  : _c("i", { class: plugin.icon }),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "typographies-paragraph-medium-semibold" },
                  [_vm._v(_vm._s(plugin.label))]
                )
              ],
              1
            )
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.permissions.can_add_module
      ? _c(
          "div",
          { staticClass: "settings-internal-plugins__add-module" },
          [
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__("settings.SettingsInternalPlugin.add_modules"),
                type: "secondary"
              },
              on: { click: _vm.redirectionAddModules }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }